module.exports = __webpack_public_path__ + "static/media/zeek.49af6215.svg";